<template>
  <v-app id="app-container">
    <v-main>
      <main-header></main-header>
      <router-view :key="route.fullPath" />
    </v-main>
    <v-dialog v-model="appStore.isLoading" max-width="400px" persistent>
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div>Loading...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script setup>
import { useRoute, RouterView } from 'vue-router'
import MainHeader from '@/components/MainHeader.vue'
import { useAppStore } from './stores/app'
const appStore = useAppStore()
const route = useRoute()
</script>
<style scoped>
nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
